export const componentHeirarchyMap = new Map<string, number>([
  ['home', 0],
  ['claim', 63],
  ['admin', 70],
  ['client', 75],
  ['user', 99],
  ['um', 71],
  ['ur', 100],
  ['request', 109]
])